// ─── Ledger-specific SUI Hooks ───────────────────────────────────────────
import { useSuiClientQuery, useCurrentAccount } from '@mysten/dapp-kit';
import { AGU_TOKEN_TYPE, AGU_DECIMALS, PACKAGE_ID, OBJECTS } from './constants';

export function useAGUBalance() {
  const account = useCurrentAccount();
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getBalance',
    { owner: account?.address ?? '', coinType: AGU_TOKEN_TYPE },
    { enabled: !!account?.address },
  );
  const raw = BigInt((data as any)?.totalBalance ?? '0');
  const balance = Number(raw) / 10 ** AGU_DECIMALS;
  return { balance, rawBalance: raw, isLoading, error, refetch, address: account?.address };
}

export function useAGUTransactions() {
  const account = useCurrentAccount();
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'queryTransactionBlocks',
    {
      filter: { FromAddress: account?.address ?? '' },
      options: { showInput: true, showEvents: true, showEffects: true },
      limit: 20,
      order: 'descending',
    },
    { enabled: !!account?.address },
  );
  const txs = ((data as any)?.data ?? []).map((tx: any) => ({
    digest: tx.digest,
    timestamp: tx.timestampMs ? new Date(Number(tx.timestampMs)).toISOString() : null,
    success: tx.effects?.status?.status === 'success',
    gasUsed: tx.effects?.gasUsed,
    events: tx.events || [],
  }));
  return { txs, isLoading, error, refetch };
}

export function useAgentRegistry() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.agentRegistry, options: { showContent: true } },
  );
  let info = { agentCount: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = { agentCount: Number(f.agent_count || 0) };
    }
  }
  return { info, isLoading, error, refetch };
}
